import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import { getLeagueVisuals } from "../consts/leagueVisuals";
import { waitForImages } from "../utils/waitForImages";
import "./StartingFive.scss";

const StartingFive = ({ props }) => {
  const startingFiveRef = useRef(null);
  const [image, setImage] = useState(null);
  const [fontColor, setFontColor] = useState("white");
  const [matchNameColor, setMatchNameColor] = useState("white");
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    const {
      startingFiveImage,
      startingFiveFontColor,
      startingFiveMatchNameColor,
    } = getLeagueVisuals(props.league);
    setImage(startingFiveImage);
    setFontColor(startingFiveFontColor);
    setMatchNameColor(startingFiveMatchNameColor);
  }, [props.league]);

  const exportStartingFive = async () => {
    const startingFive = startingFiveRef.current;
    if (!startingFive) {
      return;
    }

    setIsExporting(true);

    try {
      await waitForImages(startingFive);
      const blob = await window.domtoimage.toBlob(startingFive);
      const filename = props.match ? `${props.match}.png` : "starting-five.png";
      window.saveAs(blob, filename);
    } catch (error) {
      console.error(error);
      alert("Starting five export failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="starting-five-wrapper">
      <div
        ref={startingFiveRef}
        className="starting-five"
        style={{ backgroundImage: image ? `url(${image})` : undefined }}
      >
        <div className="starting-team-names">
          <span className="starting-home-team-name">
            {props.homeTeam?.name?.toUpperCase() ?? ""}
          </span>
          <span
            className="starting-away-team-name"
            style={{ color: fontColor }}
          >
            {props.awayTeam?.name?.toUpperCase() ?? ""}
          </span>
        </div>
        <div className="starting-five-players">
          <div className="home-starting-five">
            {props.homePlayers?.map((player) => {
              if (player.is_starter) {
                return (
                  <div
                    className={`starting-five-player ${player.position}`}
                    key={player.id}
                    style={{ color: fontColor }}
                  >
                    <span className="starting-five-player-position">
                      {player.position}
                    </span>
                    <div className="starting-five-player-name-wrapper">
                      <span className="starting-five-player-name">
                        {player.name.toUpperCase()}
                      </span>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
          <div className="away-starting-five">
            {props.awayPlayers?.map((player) => {
              if (player.is_starter) {
                return (
                  <div
                    className={`starting-five-player ${player.position}`}
                    key={player.id}
                  >
                    <span className="starting-five-player-position">
                      {player.position}
                    </span>
                    <div className="starting-five-player-name-wrapper">
                      <span className="starting-five-player-name">
                        {player.name.toUpperCase()}
                      </span>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
        <div className="starting-match-name-wrapper">
          <div
            className="starting-match-name"
            style={{ color: matchNameColor }}
          >
            {props.match}
          </div>
        </div>
      </div>
      <Button
        variant="outlined"
        sx={{ margin: "0.5rem" }}
        onClick={exportStartingFive}
        disabled={isExporting}
      >
        {isExporting ? "Generating..." : "Download"}
      </Button>
    </div>
  );
};

export default StartingFive;
